import { z } from "zod";
import { cupDateSchema, yearSchema } from "./util";

export const cupNewSchema = z.object({
	id: z.string().transform((id) => parseInt(id)),
	name: z.string(),
	anons: z.string(),
	detail_text: z.string(),
	date: cupDateSchema,
	year: z.string(),
	time: z.string(),
	name_sponsor: z.string(),
	pic_sponsor: z.string().nullable(),
	mini_pic: z.string().nullable().optional(),
	top_pic: z.string().nullable().optional(),
	images: z.array(z.string()),
});

export type CupNewType = z.infer<typeof cupNewSchema>;
